export default {
  farm: {
    locationType: "Locatietype",
    viewLocation: "Locatie Bekijken",
    Circular: "Cirkelvormig",
    Polygon: "Veelhoek",
    selectFarmToEnableCalenderView:
      "Selecteer Boerderij om Kalenderweergave in te schakelen",
    farmActivities: "Boerderijactiviteiten",
    scheduledActivities: "Geplande activiteiten",
    completedActivities: "Voltooide activiteiten",
    listView: "Lijstweergave",
    calendarView: "Kalenderweergave",
    search: "Zoeken",
    filterByFarmName: "Filter op farmnaam",
    filterByCropType: "Filter op gewastype",
    filterByStartDate: "Filter op startdatum",
    cropName: "Naam van het gewas",
    Name: "Naam",
    activities: "Activiteiten",
    startDate: "Startdatum",
    endDate: "Einddatum",
    activityDetails: "Activiteit details",
    organic: "Biologisch",
    conventional: "Conventioneel",
    technicianName: "Naam technicus",
    farmerId: "Boer ID",
    farmAddress: "Adres van de Boerderijlocatie",
    farmID: "Boerderij ID",
    farmIdPlaceHolder: "Voer de Boerderij ID in",
    onTheFarm: "Op de Boerderij",
    userRoles: "Gebruikersrollen",
    adduser: "Gebruiker Toevoegen",
    addAuser: "Voeg een Gebruiker Toe",
    uploadUsers: "Gebruikers Uploaden",
    addNewUser: "Nieuwe Gebruiker Toevoegen",
    selectDept: "Selecteer Afdeling",
    selectRole: "Selecteer Rol",
    editUser: "Gebruiker Bewerken",
    totalFarms: "Totale Boerderijen",
    NoAnimalsRegisteredForthisFarm:
      "Geen Dieren Geregistreerd voor deze Boerderij",
    farmsPerPage: "Boerderijen per Pagina",
    regularFarms: "Reguliere Boerderijen",
    farmRegisteredProducts: "Geregistreerde Producten van de Boerderij",
    searchByFarmNameAndId: "Zoeken op Boerderijnaam en ID",
    loadingProductsPleaseWait: "Laden Producten... Even geduld aub",
    farmName: "Boerderij Naam",
    nameOfTheFarm: "Naam van de Boerderij",
    farmLocation: "Locatie van de Boerderij",
    productName: "Naam van het Product",
    stockStatus: "Voorraadstatus",
    inStock: "Op Voorraad",
    searchByProductName: "Zoeken op Productnaam",
    productCategory: "Productcategorie",
    products: "Producten",
    longitude: "Lengtegraad",
    latitude: "Breedtegraad",
    farms: "Boerderijen",
    zones: "Zones",
    registerAfarm: "Registreer een Boerderij",
    govtRegistry: "Overheidsregistratie",
    cooperativeId: "ID van Coöperatie/Unie",
    cooperativeName: "Naam van de Coöperatie/Unie",
    factory: "Fabriek",
    farmType: "Boerderij Type",
    contractMating: "Contractuele Voortplanting",
    customization: "Aanpassing",
    recordsPerpage: "Records per Pagina",
    restoreDefault: "Standaard Herstellen",
    apply: "Toepassen",
    CommunityName: "Naam van de Gemeenschap",
    corporateName: "Bedrijfsnaam",
    corporateRegistrationNum: "Bedrijfsregistratienummer",
    corporateMailingAddress: "Bedrijfs Postadres",
    communityName: "Naam van de Gemeenschap",
    searchState:
      "Zoeken op Boerderij ID, Overheidsregistratie, Coöperatie ID, Boerderij Type, Contractuele Voortplanting",
    farmOwner: "Eigenaar van de Boerderij",
    govRegistrationNo: "Overheidsregistratienummer",
    farmInformation: "Boerderij Informatie",
    ownershipType: "Eigendomstype",
    farmLicenseInformation: "Boerderij Licentie Informatie",
    licenseNumber: "Licentienummer",
    licenseExpiryDate: "Vervaldatum Licentie",
    regulatorName: "Naam van de Regulator",
    regulatorRepresentativeName:
      "Naam van de Vertegenwoordiger van de Regulator",
    farmLocationSize: "Locatie en Grootte van de Boerderij",
    productionSystem: "Teeltsysteem",
    productionSystemNew: "Productiesysteem",
    goals: "Doelen",
    country: "Land",
    farmer: "Boer",
    commodity: "Goederen",
    quantity: "Hoeveelheid",
    unit: "Eenheid",
    price: "Prijs",
    save: "Opslaan",
    stateIsReq: "Staat is vereist",
    cityIsReq: "Stad is vereist",
    addressIsReq: "Adres is vereist",
    membershipTypeReq: "Type Lidmaatschap is vereist",
    extendedReasonReq: "Reden voor Uitbreiding is vereist",
    numberOfDaysReq: "Aantal Dagen is vereist",
    extendedMembershipValidity: "Verlengde Lidmaatschap Geldigheid",
    set: "INSTELLEN",
    adminRole: "Admin Rol",
    typeMsg: "Typ hier je bericht",
    errors: {
      cannotBeBlank: "Dit veld mag niet leeg zijn",
      required: "Dit veld is verplicht",
      somethingWentWrong: "Er is iets misgegaan. Probeer het later opnieuw.",
    },
    loadingData: "Gegevens laden...",
    markAsRead: "Markeren als gelezen",
    membership: {
      remainingDays: "Resterende dagen",
      type: "Type lidmaatschap",
      validity: "Geldigheid lidmaatschap",
      validityLength: {
        custom: "Aangepast",
        expired: "Verlopen",
        oneTo8Months: "1-8 maanden",
        lessThan1Month: "Minder dan 1 maand",
        moreThan1Month: "Meer dan 1 jaar",
        sixTo12Months: "6-12 maanden",
      },
    },
    of: "van",
    ok: "Oke",
    statusItems: {
      closed: "Gesloten",
      open: "Open",
    },
    orderByItems: {
      all: "Alle",
      dateAscending: "Oplopende datum",
      dateDescending: "Aflopende datum",
      dueDate: "Vervaldatum",
      high: "Hoog",
      low: "Laag",
      medium: "Gemiddeld",
    },
    orderBy: "Sorteren op",
    uploadImageVideo: "Afbeeldingen/video's uploaden",
    user: "Gebruikers",
    topics: "Onderwerpen",
    date: "Datum",
    addNew: "Nieuw toevoegen",
    exportAsCsv: "Exporteren als CSV",
    noData: "Geen gegevens gevonden",
    login: {
      welcomeMsg: "Welkom! Log in",
      info: "Voer uw referenties in",
      forgot: "Wachtwoord vergeten?",
      btn: "Inloggen",
      unableToLogin: "Kan niet inloggen",
    },
    forgot: {
      info_l1:
        "Voer het aan uw account gekoppelde e-mailadres in. Uw wachtwoordgegevens worden naar uw e-mailadres gestuurd.",
      info_l2:
        "Voer uw mobiele nummer in dat aan het account is gekoppeld. Uw wachtwoordgegevens worden naar uw mobiele nummer gestuurd.",
      forgotQ: "Wachtwoord vergeten?",
      loginNow: "Log nu in",
      resetSucc: "Uw wachtwoord is succesvol gereset.",
      resetSucc_l2:
        "U kunt nu uw nieuwe wachtwoord gebruiken om in te loggen op uw account.",
      entPsw: "Voer uw nieuwe wachtwoord in.",
      resetPsw: "Wachtwoord opnieuw instellen",
      resendOTP: "Verstuur OTP opnieuw",
      enterCorrectOTP: "Voer de juiste OTP in.",
      enterOTP: "Voer de ontvangen OTP in uw e-mail/mobiel in.",
      backToLoginPage: "Terug naar de inlogpagina",
    },

    permissions: {
      savePermissions: "Machtigingen opslaan",
      moduleName: "Module naam",
      view: "Bekijken",
      create: "Creëren",
      update: "Bijwerken",
      delete: "Verwijderen",
      permissionsUpdated: "Machtigingen bijgewerkt",
      permissionsNotUpdated: "Machtigingen niet bijgewerkt",
      selectMembership: "Selecteer lidmaatschap",
      noPermMsg:
        "Selecteer het lidmaatschapstype met behulp van het vervolgkeuzemenu 'Lidmaatschapstype' hierboven om de machtigingen te bekijken",
      selectRoleMsg:
        "Selecteer de rol hierboven om de machtigingen te bekijken",
    },
    logs: {
      time: "Tijd",
      username: "Gebruikersnaam",
      role: "Rol",
      terminalID: "Terminal-ID",
      moduleAccessed: "Toegang tot module",
      typeOfAccess: "Type toegang",
      activityLogDetails: "Details van activiteitenlogboek",
      userId: "Gebruikers-ID",
      lastLogin: "Laatste aanmelding",
      geoAccPoint: "Geo-toegangspunt",
      ipAdd: "IP-adres",
      filesAccessed: "Geopende bestanden",
      funAccessed: "Geopende functie",
      webUrl: "Web-URL",
      unsuccAtmp: "Mislukte aanmeldingspogingen",
      view: "Bekijken",
      membershipType: "Type lidmaatschap",
    },

    membershipplanSection: {
      defaultPlan: "Standaardplan",
      planType: "Type plan",
      planDuration: "Duur van het plan",
      planFee: "Planvergoeding",
      satelliteReport: "Satellietrapporten",
      advanceReport: "GEAVANCEERD RAPPORT",
      addMembership: "Lidmaatschap toevoegen",
      addMembershipPlan: "Lidmaatschapsplan toevoegen",
      accessSetelite: "Toegang tot satellietrapporten (set van 5 rapporten)",
      accessAdvanceReport: "Toegang tot geavanceerde rapporten",
      memPlanReq: "Lidmaatschapsplan is verplicht",
      memPlanReqLimit: "Lidmaatschapsplan moet minder dan 20 tekens bevatten",
      SatelliteReq: "Satellietrapport is verplicht",
      advancedReportReq: "Geavanceerd rapport is verplicht",
      durationReq: "Duur van het lidmaatschap is verplicht",
      feeReq: "Lidmaatschapsvergoeding is verplicht",
      cantLesThenZero: "Mag niet minder dan 0 zijn",
      roleReq: "Gebruikersrol is verplicht",
    },
    tickets: {
      actions: {
        create: "Ticket aanmaken",
        delete: "Ticket verwijderen",
        edit: "Ticket bewerken",
      },
      areaOfRequest: "Gebied van aanvraag",
      assignee: "Toegewezene",
      deleteTicket: {
        confirmation: "Weet u zeker dat u het ticket wilt verwijderen?",
      },
      dueDate: "Vervaldatum",
      filters: {
        ticketFor: "Ticket voor",
      },
      form: {
        ticketType: {
          admin: "Ticket aanmaken voor Admin Dimitra",
          user: "Ticket aanmaken voor app-gebruiker",
        },
      },
      markAsRead: "Markeren als gelezen",
      messages: {
        created: {
          success: "Ticket succesvol aangemaakt",
        },
        deleted: {
          success: "Ticket succesvol verwijderd",
        },
      },
      noData: "Geen gegevens gevonden",
      noDataHelpText: `U heeft geen toegewezen tickets. Klik op de knop "Ticket aanmaken" bovenaan het scherm om te beginnen.`,
      pickerInMenu: "Selector in het menu",
      priority: {
        high: "Hoog",
        label: "Prioriteit",
      },
      reply: "Antwoorden",
      requestedDateTime: "Aangevraagde datum en tijd",
      requestorDetails: "Gegevens van de aanvrager",
      requestorEmail: "E-mail van de aanvrager",
      subject: "Onderwerp",
      ticketsForItems: {
        all: "Allemaal",
        dimitraAdmin: "Admin Dimitra",
        multipleUsers: "Meerdere gebruikers",
        singleUser: "Enkele gebruiker",
      },
      title: "Tickets",
    },

    faqSection: {
      createFaq: "FAQ aanmaken",
      createTopic: "Onderwerp aanmaken",
      selectTopic: "Onderwerp selecteren",
      faqQuestion: "Veelgestelde vraag",
      faqAnswer: "Antwoord op veelgestelde vraag",
      uploadImgVid: "Afbeelding/video uploaden",
      disInFaq: "Tonen in de FAQ-sectie",
      editFaq: "Veelgestelde vragen bewerken",
      topicName: "Naam van het onderwerp",
      parentTopic: "Hoofdonderwerp",
      editTopic: "Onderwerp bewerken",
      createSection: "Maak eerst een sectie aan",
      createTopicFirst: "Maak eerst een onderwerp aan",
      questionReq: "Vraag van de FAQ is verplicht",
      answerReq: "Antwoord van de FAQ is verplicht",
    },
    reports: {
      male: "Man",
      female: "Vrouw",
      other: "Anders",
      farmerName: "Boerderijnaam",
      farmerNameId: "Naam van de Boer / ID",
      farmNameLocation: "Naam van de Boerderij/ Locatie",
      farmerProdChart: "Grafiek van Boerderijproductie",
      production: "Productie",
      byProduction: "Op Productie",
      byName: "Op Naam",
      descending: "Aflopend",
      ascending: "Oplopend",
      buyingStationProdChart: "Grafiek van Productie bij Koopstation",
      buyingStation: "Koopstation",
      buyingStationName: "Naam van Koopstation",
      dryMilling: "Droog Malen",
      dryMillingName: "Naam van Droog Malen",
      dryMillingProdChart: "Grafiek van Droog Malen Productie",
      view: "Bekijk",
      date: "Datum",
      reports: "Rapporten",
      today: "Vandaag",
      week: "Week",
      month: "Maand",
      year: "Jaar",
      all: "Alles",
      selectCrop: "Selecteer Gewas",
      selectRegion: "Selecteer Regio",
      selectProvinceState: "Selecteer Provincie/Status",
      downloadPdfReport: "Download PDF-rapport",
      export: "Exporteer",
      search: "Zoeken",
      yield: "Opbrengst",
      avgAreaPerUnit: "Gemiddeld oppervlak in {unit}",
      yeildPerUnit: "Opbrengst/{unit}",
      averageSellingPriceByAllFarmers:
        "Gemiddelde Verkoopprijs door Alle Boeren",
      averageSellingPricePerFarmer: "Gemiddelde Verkoopprijs per Boer",
      pricePaid: "Betaalde Prijs",
      pests: {
        pestReport: "Plaagrapport",
        filterByCrops: "Filteren op gewassen",
        pestStatistics: "Plaagstatistieken",
        regions: "Regio's",
        occurrences: "Voorvallen",
        pestChart: "Grafiek van plagen",
        totalArea: "Totaal oppervlak",
        pestName: "Naam van de plaag",
        region: "Regio",
        crop: "Gewassen",
        listByLand: "Lijst per land",
      },
      regions: {
        regionalReport: "Regionaal rapport",
        listByFarm: "Lijst per boerderij",
        listByFarmers: "Lijst per boeren",
        listByYield: "Lijst per opbrengst",
        regionalStatistics: "Regionale statistieken",
        countries: "Landen",
        states: "Staten/Provincies",
        city: "Stad/Dorp",
        farmsIn: "Boerderijen in",
        regionalChart: "Regionale grafiek",
        farms: "Boerderijen",
        regionName: "Naam van de regio",
        farmers: "Boeren",
        yield: "Opbrengst/Acre",
      },
    },
    cacaoTraceability: {
      traceability: "Trazabilidad",
      cacaoTraceabilityMngmnt: "Beheer van cacaotraceerbaarheid",
      traceabilityPage: "Traceerbaarheidspagina",
      labelDesigner: "Labelontwerper",
      additionalInformation: "Aanvullende informatie",
      info1:
        "Biedt informatie over aanvullende logo's van uw product. Deze informatie is beschikbaar voor het publiek op de cacaotraceerbaarheidspagina.",
      addSlogan: "Slogan toevoegen",
      additionalLogos: "Aanvullende logo's",
      title: "Titel",
      description: "Beschrijving",
      mapLink: "Kaartlink",
      websiteLink: "Websitelink",
      addMedia: "Media toevoegen",
      uploadImageVideo: "Afbeelding/video uploaden",
      origin: "Herkomst",
      info2:
        "Biedt informatie over het land van herkomst van uw product. Deze informatie is beschikbaar voor het publiek op de cacaotraceerbaarheidspagina.",
      countryImage: "Afbeelding van het land",
      institutionalInfo: "Institutionele informatie",
      info3:
        "Biedt informatie over uw bedrijf/coöperatie, vertel consumenten over het relevante werk dat u heeft gedaan. Deze informatie is beschikbaar voor het publiek op de cacaotraceerbaarheidspagina.",
      cooperativeLogo: "Coöperatief logo",
      traceabilityIntro: "Inleiding tot traceerbaarheid",
      info4:
        "Deze sectie geeft consumenten toegang tot de volledige geschiedenis van de productie en verwerking van cacao. Beschrijf het belang van traceerbaarheid voor uw bedrijf/coöperatie en voor de wereld.",
      addLabel: "Label toevoegen",
      chooseTitle: "Titel kiezen",
      chooseLabelDesign: "Labelontwerp sjabloon kiezen",
      uploadYourLogo: "Upload uw logo",
      info5:
        "Instructies: De afbeeldingsgrootte moet minimaal 1000 x 1000 pixels zijn. U kunt een transparante PNG kiezen die past bij de achtergrondkleuren.",
      chooseTemplateColors: "Sjabloonkleuren kiezen",
      backgroundColor: "Achtergrondkleur",
      foregroundColor: "Voorgrondkleur",
      labelStatus: "Labelstatus",
      inactive: "Inactief",
      download: "Downloaden",
      enterLabelTitle: "Voer de titel van het label in",
    },
    setting: {
      profileAuthSetting: "Profiel Authenticatie Instelling",
      logInOutSetting: "Inloggen/Uitloggen Instelling",
      autoLogout: "Automatisch Uitloggen",
      unsuccessfulLoginAttempt: "Mislukte Inlogpogingen",
      unsuccessfulLoginLockPeriod:
        "Periode van Inlogblokkade bij Mislukte Pogingen",
      passCriteriaSetup: "Wachtwoordcriteria-instellingen",
      passLength: "Wachtwoordlengte",
      noUniquePassRequired: "Aantal vereiste unieke wachtwoorden",
      maxPassAge: "Maximale leeftijd wachtwoord",
      acceptableRangeOfChars: "Aanvaardbaar bereik van tekens",
      upperCase: "Hoofdletters",
      lowerCase: "Kleine letters",
      numbers: "Cijfers",
      specialChars: "Speciale tekens",
      uniqueSymbols: "Unieke symbolen",
      loadingData: "Gegevens laden...",
      currency: "Valuta",
      codeActivationTime: "Tijd voor activatiecode",
      changeGlobalSetting: "Wijzig globale instelling",
      globalSetting: "Globale instelling",
      generalSetting: "Algemene instelling",
      hours: "Uren",
      days: "Dagen",
      minutes: "Minuten",
      perDay: "Per dag",
      perHour: "Per uur",
      customised: "Aangepast",
    },

    plantation: {
      farmerName: "Naam van de boer",
      phoneNumber: "Telefoonnummer",
      plantationName: "Naam van de plantage",
      farm: "Boerderij",
      location: "Locatie",
      updatePlantationStatus: "Plantatiestatus bijwerken",
      update: "Bijwerken",
    },
    activationKey: {
      enterActivationKey:
        "Voer de activeringssleutel in om een nieuwe gebruiker te registreren",
      activationKeyRequired: "Activeringssleutel vereist",
      activationKeyLimit: "Minimaal 15 tekens",
      countryRequired: "Landcode is verplicht",
      activationKey: "Activeringssleutels",
      appointSalesManager: "Benoem verkoopmanager",
      appointManager: "BENOEM MANAGER",
      salesManAppSuccess: "VERKOOPMANAGER SUCCESVOL BENOEMD",
      uploadData: "UPLOAD TOEGEWEZEN DATACSV",
      uploadUserData: "Upload gebruikersgegevensbestand",
      downloadCsv:
        "(Download het voorbeeld .csv-bestand om de structuur te volgen)",
      downloadSample: "Voorbeeldbestand downloaden",
      dragDrop: "Sleep en laat los of blader door uw bestand ",
      browse: "bladeren",
      yourFile: "uw bestand",
      incorectFileType: "Onjuist bestandstype",
      somethingWentWrong: "Er is iets misgegaan. Probeer het later opnieuw. ",
      fileUploadedSuccess: "Het bestand is succesvol geüpload",
      countRecords: "Aantal records tellen",
      sendNow: "NU VERZENDEN",
      fileName: "Bestandsnaam",
      assignActKey: "Activeringssleutels toewijzen",
      actKeyAssSucc: "Activeringssleutels succesvol toegewezen",
      viewActKey: "ACTIVERINGSSLEUTELS BEKIJKEN",
      actKeyQuota: "Activeringssleutelquotum",
      genActKey: "Gegenereerde activeringssleutels",
      remActKey: "Resterende activeringssleutels",
      penUsed: "Uitstaande en gebruikte sleutels",
      activationKeyAss: "Toegewezen activeringssleutels",
      activationKeyUnass: "Niet-toegewezen activeringssleutels",
      keysAct: "Geactiveerde sleutels",
      uploadedFiles: "Geüploade bestanden",
      generateActKey: "ACTIVERINGSSLEUTELS GENEREREN",
      showData: "Gegevens weergeven",
      noDataFound: "Geen gegevens gevonden",
      pleaseGenKey:
        'Genereer activeringssleutels met "Activeringssleutels genereren"',
      noActKey: "Geen activeringssleutels gegenereerd",
      buttonAbv: "knop hierboven",
      numberOfActKey: "Aantal activeringssleutels",
      membershipRole: "Lidmaatschapsrol",
      membershipPlan: "Lidmaatschapsplan",
      comments: "Opmerkingen",
      genKeys: "SLEUTELS GENEREREN",
      keysNum: "Aantal sleutels",
      phoneNumber: "Telefoonnummer",
      keysStatus: "Sleutelstatus",
      ActivationKeysList: "Lijst met activeringssleutels",
      back: "TERUG",
      usingActKeys:
        'Genereer activeringssleutels met "Activeringssleutels genereren""',
      pleaseGenActKeyss: "Genereer activeringssleutels",
      clearAllFilters: "ALLE FILTERS WISSEN",
      salesManager: "Verkoopmanager",
      clearAll: "ALLES WISSEN",
      generatedBy: "Gegenereerd door",
      numberOfKeys: "Aantal sleutels",
      action: "Actie",
      viewAllUplFiles: "Alle geüploade bestanden bekijken",
      bulkUploadUsers: "Meeste gebruikers uploaden",
      noActivationKeyFound: "Geen activeringssleutels gevonden",
      pleaseCreateAdminRole: "Maak de admin-rol aan met de",
      btnCreateAdmin: 'knop "Admin-rol aanmaken" hierboven',
      donwloadAsCsv: "Downloaden als CSV",
      donwloadAsPdf: "Downloaden als PDF",
      assignSalesManager: "Verkoopmanager toewijzen",
      shareViaEmail: "Delen via e-mail",
      sendEmail: "E-MAIL VERZENDEN",
      emailSend: "E-mail succesvol verzonden",
      donwload: "Downloaden",
      deleteFile: "Bestand verwijderen",
      invalidFileData: "Ongeldige activeringssleutelgegevens in het bestand",
    },
    traceability: {
      traceability: "traceerbaarheid",
      coffeeTraceabilityMngmnt: "Koffie Traceerbaarheidsbeheer",
      traceabilityPage: "Traceerbaarheidspagina",
      labelDesigner: "Labelontwerper",
      additionalInformation: "Aanvullende informatie",
      info1:
        "Geef informatie over aanvullende logo's van uw product. Deze informatie is beschikbaar voor het publiek op de koffietraceerbaarheidspagina.",
      addSlogan: "Slogan toevoegen",
      additionalLogos: "Aanvullende logo's",
      title: "Titel",
      description: "Omschrijving",
      mapLink: "Mapkoppeling",
      websiteLink: "Websitekoppeling",
      addMedia: "Media toevoegen",
      uploadImageVideo: "Afbeelding/Video uploaden",
      uploadImage: "Afbeelding uploaden",
      origin: "Oorsprong",
      info2:
        "Geef informatie over het land van herkomst van uw product. Deze informatie is beschikbaar voor het publiek op de koffietraceerbaarheidspagina.",
      countryImage: "Landafbeelding",
      institutionalInfo: "Institutionele informatie",
      info3:
        "Geef informatie over uw bedrijf/coöperatie, vertel consumenten over het relevante werk dat u hebt gedaan. Deze informatie is beschikbaar voor het publiek op de koffietraceerbaarheidspagina.",
      cooperativeLogo: "Coöperatief logo",
      traceabilityIntro: "Inleiding tot traceerbaarheid",
      info4:
        "Deze sectie stelt consumenten in staat toegang te krijgen tot de volledige productie- en verwerkingsgeschiedenis van de koffie. Beschrijf het belang van traceerbaarheid voor uw bedrijf/coöperatie en voor de wereld.",
      addLabel: "Label toevoegen",
      chooseTitle: "Titel kiezen",
      chooseLabelDesign: "Labelontwerp sjabloon kiezen",
      uploadYourLogo: "Upload uw logo",
      info5:
        "Instructies: De afbeeldingsgrootte moet minimaal 1000 x 1000 pixels zijn. U kunt kiezen voor een transparante PNG om aan te sluiten bij de achtergrondkleuren.",
      chooseTemplateColors: "Sjabloonkleuren kiezen",
      backgroundColor: "Achtergrondkleur",
      foregroundColor: "Voorgrondkleur",
      labelStatus: "Labelstatus",
      inactive: "Inactief",
      download: "Downloaden",
    },

    dashboardReports: {
      appDataReports: "Rapporten van Applicatiegegevens",
      reports: "Rapporten",
    },
    cropsReport: "Gewassenrapport",
    today: "Vandaag",
    week: "Week",
    month: "Maand",
    year: "Jaar",
    all: "Alles",
    cropsStatistics: "Gewasstatistieken",
    crops: "Gewassen",
    acres: "Hectaren",
    totalPlantedArea: "Totale Geplante Oppervlakte",
    farmersChart: "Grafiek van Boeren",
    cropsName: "Naam van de Gewassen",
    farmers: "Boeren",
    planted: "Geplant",
    plantedArea: "Geplante Oppervlakte",
    harvested: "Geoogst",
    yieldAcre: "Opbrengst per Hectare",
    selectCrop: "Selecteer Gewas",
    listByYield: "Lijst op basis van Opbrengst",
    listByPlantedArea: "Lijst op basis van Geplante Oppervlakte",
    equipmentReport: "Rapport van Apparatuur",
    equipmentChart: "Grafiek van Apparatuur",
    selectFarmer: "Selecteer Boer",
    selectFarmers: "Selecteer Boeren",
    equipmentName: "Naam van de Apparatuur",
    region: "Regio",
    counts: "Aantallen",
    large: "Groot",
    medium: "Middelgroot",
    small: "Klein",
    listByFarmer: "Lijst op basis van Boer",
    rowsPerPage: "Rijen per Pagina",
    farmersReport: "Boerenrapport",
    farmersStatistics: "Boerenstatistieken",
    averageFarmerLand: "Gemiddeld Boerenland",
    largeFarmers: "Grote Boeren",
    mediumFarmers: "Middelgrote Boeren",
    smallFarmers: "Kleine Boeren",
    listByLand: "Lijst op basis van Land",
    listByFarm: "Lijst op basis van Boerderij",
    AvgLandAcre: "Gemiddeld Land per Hectare",
    listbyCrop: "Lijst op basis van Gewas",
    listbyZone: "Lijst op basis van Zone",
    area: "Oppervlakte",
    goalsAchievedReport: "Rapport van Bereikte Doelen",
    listByCrops: "Lijst op basis van Gewassen",
    goalsAchievedChart: "Grafiek van Bereikte Doelen",
    goalsAchieved: "Bereikte Doelen",
    goalsFailed: "Mislukte Doelen",
    successRate: "Succespercentage",
    achieved: "Bereikt",
    equipment: "Apparatuur",
    pests: "Plagen",
    regions: "Regio's",
    filterByCrops: "Filteren op Gewassen",
    searchCrops: "Zoek Gewassen",
    batchCode: "Batchcode",
    batchRating: "Batchbeoordeling",
    MakeASelection: "Maak een Selectie",
    typeTotalCoffeeQuantity: "Voer de Totale Hoeveelheid Koffie in",
    typeHumidity: "Voer de Vochtigheid in",
    valueInPercent: "Waarde in Procent",
    purchaseOrderRequired: "Inkooporder vereist",
    totalCoffeeCherryRequired: "Totale Hoeveelheid Koffiekers vereist",
    processTypeRequired: "Procestype vereist",
    stationInfo: "Stationinformatie",
    purchaseOrders: "Inkooporders",
    processingBatch: "Verwerkingsbatch",
    processedCoffeeOutRequired: "Verwerkte Koffie vereist",
    lotNo: "Lotnummer",
    addNewS: "Nieuwe Toevoegen",
    viewAll: "Alles Bekijken",
    parchmentOut: "Geparchmenteerd Uit",
    processingDone: "Verwerking Voltooid",
    farmerLotID: "Boerderij-ID en Lotnummer",
    weight: "Gewicht",
    plantationSettings: "Instellingen voor Plantage",
    PlantationsEachFarmerCanCreate:
      "Aantal Plantages dat Elke Boer Kan Creëren",
    manageAdditionalPlantationRequests: "Beheer Extra Plantageverzoeken",
    autoApprove: "Automatisch Goedkeuren",
    adminApprovalRequired: "Goedkeuring van Beheerder Vereist",
    close: "Sluiten",
    new_user: "Nieuwe Gebruiker",
    KGAcre: "KG/Hectare",
    pending: "In Afwachting",

    //dashboard report
    "Farmer Name": "Naam van de Boer",
    "Goals Achieved": "Bereikte Doelen",
    "Goals Failed": "Mislukte Doelen",
    "Success Rate": "Succespercentage",

    "Equipment Name": "Naam van de Apparatuur",
    Region: "Regio",
    Farmer: "Boer",
    Counts: "Aantallen",

    "Pest Name": "Naam van de Plaag",
    "Total Area": "Totale Oppervlakte",
    Crop: "Gewas",

    "Crop Name": "Naam van het Gewas",
    Farmers: "Boeren",
    Farms: "Boerderijen",
    Planted: "Geplant",
    "Planted Area": "Geplante Oppervlakte",
    Harvested: "Geoogst",
    "Yield/acre": "Opbrengst per Hectare",
    "Region Name": "Naam van de Regio",
    "Avg. Land/Acre": "Gemiddeld Land per Hectare",
    Crops: "Gewassen",
    "Yield/area": "Opbrengst/Oppervlakte",
    "Avg. land/Acre": "Gemiddeld land/Hectare",
    "Farm Name": "Naam van de Boerderij",
    Zones: "Zones",
    Area: "Oppervlakte",

    "Goals Achieved Report": "Rapport van Bereikte Doelen",
    "Farms Report": "Boerderijenrapport",
    "Pest Report": "Plagenrapport",
    "Equipment Report": "Apparatuurrapport",
    "Crops Report": "Gewassenrapport",
    "Farmers Report": "Boerenrapport",
    "Regional Report": "Regionaal Rapport",

    state: "Staat",
    city: "Stad/Dorp",
    farmNumber: "Nummer van de Boerderij",
    postal: "Postcode",
    houseNumber: "Huisnummer",
    farmRegistration: "Registratie van de Boerderij",
    cancel: "Annuleren",
    register: "Registreren",
    totalFarmSize: "Totale Boerderijgrootte",
    farmGeographicLocation: "Geografische Locatie van de Boerderij",
    perimeterPointLongitude: "Lengte van het Perimeterpunt",
    perimeterPointLatitude: "Breedtegraad van het Perimeterpunt",
    perimeterPointLabel: "Label van het Perimeterpunt",
    perimeterLength: "Lengte van het Perimeter",
    farmLatitude: "Breedtegraad van de Boerderij",
    farmLongitude: "Lengtegraad van de Boerderij",
    editFarm: "Boerderij Bewerken",
    update: "Bijwerken",
    editAfarm: "Bewerk een Boerderij",
    nextFarm: "Volgende Boerderij",
    nameoftheFarm: "Naam van de Boerderij",
    addNewLocation: "Nieuwe Locatie Toevoegen",
    registerAProduct: "Product Registreren",
    farmProducts: "Boerderijproducten",
    calf: "Kalf",
    steer: "Stier",
    heifer: "Vaars",
    sire: "Vader",
    dam: "Moeder",
    registerAnAnimal: "Dier Registreren",
    farmAnimals: "Boerderijdieren",
    farm_type: "Type Boerderij",
    farm_Owner: "Eigenaar van de Boerderij",
    dateOfRegistration: "Registratiedatum",
    dataIsNotAvailableForThisFarm:
      "Gegevens zijn niet beschikbaar voor deze Boerderij",
    registerNewProduct: "Nieuw Product Registreren",
    information: "Informatie",
    licenseInfo: "Licentie-informatie",
    locationInfo: "Locatie-informatie",
    geoLocation: "Geografische Locatie",
    perimeterLengthState:
      "Lengte van het Perimeter van de Boerderij (lengte van het hek)",
    totalFarmSizeState: "Grootte van een Boerderij",
    productionSystemState: "Productiesysteem gebruikt op de Boerderij",
    contractMatingState:
      "Code van het Contractfokprogramma waaraan de Boerderij deelneemt",
    ownershipTypeState: "Type Eigendom",
    regulatorRepresentativeNameState:
      "Naam van de persoon die de regelgever vertegenwoordigt die de licentie heeft afgegeven",
    regulatorNameState:
      "Naam van de regelgever die de licentie heeft afgegeven",
    licenseExpiryDateState: "Datum waarop de huidige licentie vervalt",
    licenseNumberState: "Licentienummer uitgegeven door de regelgever",
    plotNumberState: "Nummer van het huis van de Boerderij",
    plotNumber: "Nummer van de Boerderij",
    streetStatement: "Naam van de straat van de Boerderij",
    cityStatement: "Stad waarin de Boerderij zich bevindt",
    farmLocationAddressInfo:
      "De locatie waar de Boerderij zijn belangrijkste landbouwactiviteit uitvoert.",

    provinceStateInfo:
      "Een belangrijke bestuurlijke divisie van een land of rijk.",
    cityInfo:
      "Een menselijke nederzetting of gemeenschap van gebouwen, groter dan een gehucht en kleiner dan een stad, gelegen in een landelijke omgeving.",
    streetNumberInfo: "Nummer van de Straat",
    totalFarmSizeInfo: "Totale Grootte van de Boerderij",
    areaUOMInfo:
      "Eenheid van maat voor de grootte van de Boerderij, bijvoorbeeld hectare, acre, etc.",
    perimeterLengthInfo: "Totale Omtrek van de Boerderij",
    permiterUOMInfo:
      "Eenheid van maat voor de omtrek van de Boerderij, bijvoorbeeld centimeter, meter, etc.",

    stateStatement: "Staat van het land waarin de Boerderij zich bevindt.",
    countryState: "Land waarin de Boerderij zich bevindt.",
    farmStateInfo: "Adres van de locatie van de Boerderij",
    perimeterPointLongitudeState: "Lengte van een punt op de Boerderij.",
    perimeterPointLatitudeState: "Breedtegraad van een punt op de Boerderij.",
    perimeterPointLabelState: "Label van het Punt.",
    farmLongitudeState: "Lengte van de Boerderij.",
    farmLatitudeState: "Breedtegraad van de Boerderij.",
    deleteFarm: "Boerderij Verwijderen",
    confirmBulkDeleteFarm:
      "Weet u zeker dat u {count} geselecteerde boerderij(en) wilt verwijderen?",
    bulkDelete: "Bulk verwijderen",
    selectFarmsToDelete: "Selecteer ten minste één boerderij om te verwijderen.",
    bulkDeleted: "{count} boerderij(en) verwijderd.",

    farmNameH: "Naam van de Boerderij",
    farmTypeH:
      "Het type Boerderij waar verschillende activiteiten worden uitgevoerd.",
    farmOwnerH:
      "Naam van de eigenaar van een Boerderij (automatisch gegenereerd bij het invoeren van de informatie)",
    ownershipTypeH:
      "Het type boeren dat het land bezit/beheert dat ze bewerken en degenen die dat niet doen.",
    govtRegNumbH:
      "Registratienummer van de Boerderij toegewezen door de regelgever",
    contractMatingH:
      "Code van het contractfokprogramma waaraan de Boerderij deelneemt",
    productionSystemH: "Productiesysteem gebruikt op de Boerderij",
    cooperativeIDH: "ID van een coöperatie waartoe de Boerderij behoort",
    licenseNumberH:
      "Identificatienummer in een licentie afgegeven door de regelgever dat de eigenaar identificeert.",
    licenseExpiryDateH: "Datum waarop de huidige licentie vervalt",
    regularNameH: "Naam van de regelgever die de licentie heeft afgegeven",
    regularRepName:
      "Naam van de persoon die de regelgever vertegenwoordigt die de licentie heeft afgegeven",
    countryH: "Land waarin de Boerderij zich bevindt.",
    stateH: "Staat van het land waarin de Boerderij zich bevindt.",
    cityH: "Stad waarin de Boerderij zich bevindt.",
    streetH: "Naam van de Straat van de Boerderij.",
    houseNumberH: "Nummer van de Boerderij.",
    totalFarmSizeH:
      "De grootte van de Boerderij is de som van het land dat momenteel wordt bewerkt door de Boerderij, inclusief braakliggend land maar exclusief land onder natuurlijke begroeiing, bomen of gras.",
    farmLatitudeH:
      "Het is de maat voor de afstand ten noorden of ten zuiden van de evenaar. Het wordt gemeten met 180 denkbeeldige lijnen die van oost naar west cirkels vormen rond de aarde, evenwijdig aan de evenaar.",
    farmLongitudeH:
      "Meet de afstand ten oosten of ten westen van de primaire meridiaan.",
    perimeterLengthH:
      "Lengte van de omtrek van de Boerderij (lengte van het hek)",
    perimeterPointLabelH:
      "Label van het punt. Met behulp van drie parameters (breedtegraad, lengtegraad en label) beschrijven we de omtrek van de Boerderij en elk segment binnen de Boerderij.",
    perimeterPointLatH: "Breedtegraad van een punt op de Boerderij",
    perimeterPointLongH: "Lengtegraad van een punt op de Boerderij",
    street: "Straat",
    registration: {
      regulatorName: "Naam van de regelgever die de licentie heeft afgegeven",
      perimeterPointLabel:
        "Label van het punt. Met behulp van drie parameters (breedtegraad, lengtegraad en label) beschrijven we de omtrek van de Boerderij en elk segment binnen de Boerderij.",
      perimeterPointLatitude: "Breedtegraad van een punt op het perceel",
      perimeterPointLongitude: "Lengtegraad van een punt op het perceel",
      farmID: "Identificatienummer toegewezen aan de Boerderij van vee",
      farmName: "Naam toegewezen aan de Boerderij van vee",
      CommunityName:
        "Naam gegeven aan een groep mensen met een gemeenschappelijke kenmerk of interesse die samenleven binnen een grotere samenleving",
      farmType:
        "Het type Boerderij kan worden geclassificeerd (gegroepeerd) op basis van het geteelde vee en hoe het wordt geteeld",
      farmOwner:
        "Iedereen die de operaties van een Boerderij bezit of controleert",
      ownershipType:
        "Het type boeren dat de Boerderij bezit/beheert en degenen die dat niet doen",
      govtRegistrationNumber:
        "Nummer gegeven door de overheidsorganisatie waarin de Boerderij is geregistreerd",
      licenseNumber: "Licentienummer uitgegeven door de regelgever",
      licenseExpiryDate: "Dag waarop de licentie ongeldig wordt voor erkenning",
      regulatorRepresentativeName:
        "Naam van de Vertegenwoordiger van de Regulator",
    },
    addFarm: "Boerderij Toevoegen",
    farmerFirstName: "Voornaam van de Boer",
    farmerMiddleName: "Tweede Naam van de Boer",
    farmerLastName: "Achternaam van de Boer",
    iAmNotFarmer: "Ik ben geen Boer",
    certifications: "Certificeringen",
    productionType: "Productietype",
    deleted: "Boerderij succesvol verwijderd.",
    notDeleted: "Boerderij niet verwijderd.",
    searchFarmName: "Zoeken op Boerderijnaam",
    pleaseSelectFarmType: "Selecteer alstublieft het type Boerderij",
    dropHere: "of sleep hier naartoe",

    farmTitleDocument: "Eigendomsdocumenten van de boerderij",
    regBy: "Geregistreerd door",
    regDate: "Registratiedatum",
    selectFarmToEnableCalendarView:
      "Selecteer alstublieft een boerderij om de kalenderview te activeren",
    noFarm: "Er is nog geen boerderij geregistreerd.",
    noFarmDescription:
      "Klik alstublieft op de knoppen hieronder om te beginnen.",
    farmRegistrationId: "ID di registrazione della fattoria",
    farmerRegistrationId: "Registratie-ID van de landbouwer",
    farmId: "ID della fattoria",
    farmerName: "Nome dell'agricoltore",
    farmOwnershipType: "Tipo di proprietà agricola",
    farmGoals: "Obiettivi della fattoria",
    farmCertifications: "Certificazioni agricole",
    farmInfo: "Informazioni sulla fattoria",
    provinceState: "Provincia/Stato",
    streetNumber: "Numero civico",
    addGeofenceForThisFarm: "Geofence toevoegen voor deze boerderij",
    pleaseClickToChooseLocation: "Klik om een locatie te kiezen",
    address: "Indirizzo",
    geographicLocation: "Posizione geografica",
    searchLocation: "Cerca posizione",
    pleaseChooseOneOfTheOption: "Kies een van de opties",
    useGeoFencingFeature: "Utilizza la funzione geofence",
    uploadShapeFile: "Carica file di forma",
    uploadGeofence: "Carica geofence",
    upload: "Carica",
    generateReport: "Genera rapporto",
    avocado: "Avocado",
    avocadoTrees: "Alberi di avocado",
    addNewFarmLocation: "Nieuwe boerderijlocatie toevoegen",
    farmLocationAddress: "Adres van de boerderijlocatie",
    useGeofenceTool: "Usa lo strumento geofence",
    geofenceIsRequiredForSatelliteReport:
      "Let op: een geofence is vereist voor satellietrapporten",
    enterHere: "Inserisci qui",
    primaryLocation: "Posizione principale",
    secondaryLocation: "Posizione secondaria",
    locationAndSize: "Posizione e dimensione",
    farmReports: "Rapporto/i",
    addNewZone: "Aggiungi nuova zona",
    noZoneMessage: "Nessuna zona registrata ancora.",
    noZoneRequest:
      "Klik op \"Nieuwe zone toevoegen\" om een zone voor deze boerderij aan te maken.",
    locationZone: "Zona di posizione",
    editFarmLocation: "Modifica posizione della fattoria",
    addZone: "Aggiungi zona",
    nameOfTheZone: "Nome della zona",
    zoneDetails: "Dettagli della zona",
    perimeter: "Perimetro",
    areaUnit: "Unità di area",
    zoneName: "Nome della zona",
    farmGeofence: "Geofence della fattoria",
    circularGeofence: "Geofence circolare",
    polygonGeofence: "Geofence poligonale",
    actions: "Azioni",
    editZone: "Modifica zona",
    numberOfGroups: "Numero di gruppi",
    numberOfTrees: "Numero di alberi",
    group: "Gruppo",
    groupName: "Nome del gruppo",
    numberOfAnimals: "Numero di animali",
    status: "Stato",
    primaryGeofence: "Geofence principale",
    walkAndMeasure: "Cammina e misura",
    clearGeofence: "Cancella geofence",
    deleteSelectedVertex: "Elimina vertice selezionato",
    basicInformation: "Informazioni di base",
    geofenceCategoryName: "Naam van de geofence-categorie",
    geofenceName: "Nome del geofence",
    farmRadius: "Raggio della fattoria",
    radiusInfo:
      "Geeft de afstand aan van een centraal punt tot de buitenrand van een cirkelvormig gebied.",
    radiusUnitInfo:
      "Verwijst naar een standaardhoeveelheid die wordt gebruikt als basis voor meting.",
    locationDisabledMessage:
      "Uw locatie is uitgeschakeld. Zoek uw locatie via de menu’s aan de linkerkant.",
    yourDistanceIs: "La tua distanza è",
    importingNote:
      "Uw geüploade bestand wordt momenteel verwerkt.\nKlik niet op annuleren, sluiten of vernieuwen om onderbreking te voorkomen.",
    bulkImportNote:
      "Download en gebruik de onderstaande sjablonen om boerderijen in bulk te importeren.",
    importCompleted: "Import voltooid",
    importantNote: "Belangrijke opmerking",
    selectFileToUpload: "Selecteer bestand om gegevens te uploaden",
    importantNoteDetail:
      "Gebruik de bovenstaande sjablonen voor bulkuploads. Andere formaten zullen tot mislukking leiden.",
    deforestationReports: "Rapport(en) over ontbossing",
    farmsAccessControl: "Toegangscontrole Boerderijen",
    chooseTheUserYouWantToManageFarmAccessFor: "Kies de gebruiker(s) waarvoor u de boerderijtoegang wilt beheren.",
    selectTheFarmYouWantToManageAccessFor: "Selecteer de boerderij waarvoor u de toegang wilt beheren.",
    proceedWithSelected: "Doorgaan met geselecteerde",
    userRole: "Gebruikersrol",
    userRoleInfo: "Gebruikersrol. De gebruikersrol bepaalt de machtigingen die de gebruiker op de boerderij heeft.",
    usersSelected: "gebruikers geselecteerd",
    viewFarmAccess: "Boerderijtoegang Bekijken",
    selectUser: "Selecteer Gebruiker",
    recordsPerPage: "Records per pagina",
    print: "Afdrukken",
    custom: "Aangepast",
    records: "Records",
    dashboard: "Dashboard",
    accessControl: "Toegangscontrole",
    technician: "Technicus",
    userNameAndId: "Gebruikersnaam en ID",
    email: "E-mail",
    userRoleAndRegDate: "Gebruikersrol / Registratiedatum",
    access: "Toegang",
    active: "Actief",
    inactive: "Inactief",
    na: "N/A",
    userDeactivated: "Gebruiker Gedeactiveerd",
    userActivated: "Gebruiker Geactiveerd",
    farmUsers: "Boerderijgebruikers",
    viewAndUpdateTheFarmsThisUserHasAccessTo: "Bekijk en update de boerderijen waartoe deze gebruiker toegang heeft",
    assignFarmsToTheSelectedUsers: "Wijs boerderijen toe aan de geselecteerde gebruikers",
    selectTheFarmsYouWantToGrantAccessToForTheChosenTechnicians: "Selecteer de boerderijen waaraan u toegang wilt verlenen voor de gekozen technici.",
    removeAccessFromSelectedFarms: "Toegang Verwijderen van Geselecteerde Boerderijen",
    grantFarmAccess: "Boerderijtoegang Verlenen",
    back: "Terug",
    s: "(s)",
    areYouSureYouWantToGrantAccessTo: "Weet u zeker dat u toegang wilt verlenen aan",
    areYouSureYouWantToRemoveAccessFrom: "Weet u zeker dat u toegang wilt verwijderen van",
    farmAccessRemoved: "Boerderijtoegang Verwijderd",
    successfullyRemovedAccessFrom: "Toegang succesvol verwijderd van",
    failedToRemoveFarmAccessPleaseTryAgain: "Verwijderen van boerderijtoegang mislukt. Probeer het opnieuw.",
    forTheFollowingUsers: "voor de volgende gebruiker(s)?",
    selectFarm: "Selecteer Boerderij",
    grantAccess: "Toegang Verlenen",
    removeAccess: "Toegang Verwijderen",
    removeFarmAccess: "Boerderijtoegang Verwijderen",
    farmAccessGranted: "Boerderijtoegang Verleend",
    successfullyGrantedAccessTo: "Toegang succesvol verleend aan",
    farm: "boerderij",
    for: "voor",
    failedToGrantFarmAccessPleaseTryAgain: "Verlenen van boerderijtoegang mislukt. Probeer het opnieuw.",
    error: "Fout",
    selectFactory: "Selecteer Fabriek",
    failedToLoadFarmsPleaseTryAgain: "Laden van boerderijen mislukt. Probeer het opnieuw.",
    farmNameAndId: "Boerderijnaam en ID",
    farmAddedBy: "Boerderij Toegevoegd Door",
    exportAsCSV: "Exporteren als CSV",
    activityLog: "Activiteitenlogboek",

    youSharedAccessOfTheFarmWithTheFollowingUsersSuccessfully: "U heeft de toegang tot de boerderij met de volgende gebruiker(s) succesvol gedeeld.",
    grantAccessToMoreUsers: "Toegang Verlenen aan Meer Gebruikers",
    areYouSureYouWantToRemoveAccessFor: "Weet u zeker dat u toegang wilt verwijderen voor",
    thisUser: "deze gebruiker",
    areYouSureYouWantToGrantAccessToThisFarmForTheFollowingUsers: "Weet u zeker dat u toegang wilt verlenen aan deze boerderij voor de volgende gebruiker(s)?",
    failedToLoadUsersPleaseTryAgain: "Laden van gebruikers mislukt. Probeer het opnieuw.",
    successfullyRemovedUserAccessFromThisFarm: "Gebruikerstoegang succesvol verwijderd van deze boerderij.",
    farmIdAndUserIdAreRequired: "Boerderij-ID en Gebruikers-ID zijn vereist.",
    noUsersSelectedPleaseSelectAtLeastOneUser: "Geen gebruikers geselecteerd. Selecteer ten minste één gebruiker.",
    successfullyGrantedAccessToThisFarmFor: "Toegang succesvol verleend aan deze boerderij voor",
    unknownUser: "Onbekende Gebruiker",
    confirm: "BEVESTIGEN",

    farmActivityLog: "Boerderij Activiteitenlogboek",
    ipAddress: "IP-adres",
    dateAndTime: "Datum en Tijd",
    module: "Module",
    activityDescription: "Activiteit Beschrijving",
    select: "Selecteer",
    addNewUsers: "Nieuwe Gebruikers Toevoegen",
    addUsersToFarm: "Gebruikers Toevoegen aan Boerderij",
    selectedUsers: "Geselecteerde Gebruikers",
    selectTheUsersToAddInFarmFromTheBelowListOfAllUserInACooperative: "Selecteer de gebruikers om toe te voegen aan de boerderij uit de onderstaande lijst van alle gebruikers in een coöperatie.",
    reviewTheSelectedUsersAndAssignTheirAccessRoles: "Bekijk de geselecteerde gebruikers en wijs hun toegangsrollen toe.",
    allRoles: "Alle Rollen",
    userRegistrationDate: "Gebruikersregistratiedatum",
    deactivated: "Gedeactiveerd",
    pleaseSelectAtLeastOneUser: "Selecteer ten minste één gebruiker",
    noUsersSelected: "Geen gebruikers geselecteerd",
    userRemoved: "Gebruiker verwijderd",
    next: "VOLGENDE",
    id: "ID",
  },
  buySell: {
    farmerName: "Naam van de boer",
    location: "Locatie",
    country: "Land",
    gender: "Geslacht",
    noOfOrdersSold: "Aantal verkochte bestellingen",
    noOfPurchaseOrders: "Aantal inkooporders",
    totalPurchaseSaleVolume: "Totale verkoopvolume",
    totalAvgValue: "Gemiddelde waarde",
    searchOrderByID: "Zoeken op bestel-ID",
    totalNumberofOrders: "Totaal aantal bestellingen",
    totalNumberOfTransactions: "Totaal aantal transacties",
    totalWeightOfTransactions: "Totaal gewicht van transacties",
    totalMonetaryValue: "Totale monetaire waarde",
    averagePrice: "Gemiddelde prijs",
  },
  plantation: {
    farmerName: "Naam van de boer",
    phoneNumber: "Telefoonnummer",
    plantationName: "Naam van de plantage",
    farm: "Boerderij",
    location: "Locatie",
    updatePlantationStatus: "Status van de plantage bijwerken",
    update: "Bijwerken",
    plantationStatus: {
      pending: "In afwachting",
      approved: "Goedgekeurd",
      rejected: "Afgewezen",
      completed: "Voltooid",
    },
  },
};
